import { CNPJ, Phone } from 'helpers/Input';
import React, { useState } from 'react'
import { Card, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { history } from 'store';
import Swal from 'sweetalert2';
import swal from '../../helpers/swal';
import masterAgentService from 'services/master-agent-request';
import { validateDocument } from '../../helpers/document'
import { useCompany } from 'models';

const CloudTelephonyForm = ({ provider }) => {
  const { company: currentCompany } = useCompany()

  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false)

  const fields = [
    // {
    //   label: "Provedor",
    //   prop: 'providers',
    //   type: 'select',
    //   options: [
    //     { value: 1, label: 'LogMeIn' },
    //     { value: 2, label: 'Net2Phone' },
    //     { value: 5, label: 'Voice Manager' }
    //   ]
    // },
    { label: 'Razão Social do Parceiro', prop: 'partner_company_name', type: 'input' },
    { label: 'Nome Parceiro', prop: 'partner_name', type: 'input' },
    { label: 'Telefone de contato', prop: 'phone', type: 'phone' },
    { label: 'Email', prop: 'email', type: 'email' },
    { label: 'Razão Social Cliente Final', prop: 'client_company_name', type: 'input' },
    { label: 'CNPJ', prop: 'cnpj', type: 'cnpj' },
    { label: 'Nome Responsável', prop: 'responsible_name', type: 'input' },
    { label: 'Email (Cliente Final)', prop: 'client_email', type: 'email' },
    { label: 'Telefone de Contato (Cliente Final)', prop: 'client_phone', type: 'phone' },
    { label: 'Resumo da oportunidade', prop: 'opportunity_resume', type: 'textarea' },
    { label: 'Previa da Quantidade de Ramais', prop: 'amount_ramal_preview', type: 'input' },
    { label: 'Localidade da Implantação – Cidade', prop: 'location_city', type: 'input' },
    { label: 'Localidade da Implantação – Estado', prop: 'location_state', type: 'input' },
    { label: 'Caso a solução seja para Matriz e filiais trabalharemos a viabilidade técnica no escopo do projeto', prop: 'scope_project', type: 'textarea' },
  ]

  const handleChangeData = (value, prop) => {
    let _aux = data
    _aux[prop] = value
    setData(_aux)
  }

  const handleGetData = (prop) => {
    return data[prop]
  }

  const renderField = field => {
    // if (field.type == "select") {
    //   return (
    //     <Select
    //       value={handleGetData(field.prop)}
    //       options={field.options}
    //       onChange={selected => handleChangeData(selected, field.prop)}
    //     />
    //   )
    // } else 
    if (field.type == "input" || field.type == "email") {
      return (
        <Form.Control
          type={field.type}
          onChange={({ target }) => handleChangeData(target.value, field.prop)}
        />
      )
    } else if (field.type == "cnpj") {
      return (
        <CNPJ onChange={({ target }) => handleChangeData(target.value, field.prop)} />
      )
    } else if (field.type == "phone") {
      return (
        <Phone onChange={({ target }) => handleChangeData(target.value, field.prop)} />
      )
    } else {
      return (
        <Form.Control
          as="textarea"
          placeholder="Ensira sua resposta"
          onChange={({ target }) => handleChangeData(target.value, field.prop)}
        />
      )
    }
  }

  const validateFields = () => {
    const showError = message => {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    let hasErrors = 0

    fields.map(field => {
      if (!data[field.prop]) {
        showError(field.label)
        hasErrors++
      } else {        
        if (field.prop == "cnpj") {
          const isValid = validateDocument(field.prop, data[field.prop])
          if (!isValid) {
            showError('CNPJ não é válido')
            hasErrors++
          }
        }
      }
    })

    return hasErrors == 0;
  }

  return (<>
    <Card className="mt-3">
      <Card.Body style={{ background: "#004B8B", color: "#FFFFFF" }}>
        <Card.Title>
          <span style={{ color: "#FFFFFF" }} className="h2">
            REGISTRO DE OPORTUNIDADE SOLUÇÕES TELEFONIA EM NUVEM - { provider.name }
          </span>
        </Card.Title>
        <Card.Text>
          Preencha o formulário abaixo para registrar um lead com a <strong><u>{ provider.name }</u></strong>, todas as informações são obrigatórias.
        </Card.Text>
        <Card.Text>
          <span className="font-weight-bold">AVISO IMPORTANTE</span>: Todas as informações apresentadas aqui são estritamente confidenciais.
          Manteremos contato somente com o responsável descrito neste formulário para alinhamento da
          oportunidade, e assim, prosseguiremos o projeto com o Provedor de Serviços, que atuará em
          conjunto com o parceiro e a ScanSource Master Agent.
        </Card.Text>
        <Card.Text>
          <span style={{ color: "#ffee00" }}>
              O RO tem validade de 90 dias, durante esse período é necessário que o parceiro nos comunique de interações no cliente final, 
              a fim de garantir o Registro de Oportunidade para sua empresa
          </span>
        </Card.Text>
        <Card.Text>
          Daremos um retorno da análise em 24 horas, para confirmação do registro.
        </Card.Text>
      </Card.Body>
      <Card.Body>
        <Row>
          <Col md="12">
            <small><span className="text-danger">*</span> Obrigatória</small><br /><br />
          </Col>
          <Col md="12">
            <Form>
              {fields.map((field, key) => (
                <Form.Group key={key}>
                  <Form.Label>{field.label}  <span className="text-danger">*</span>:</Form.Label>
                  {renderField(field)}
                </Form.Group>
              ))}

              <Button
                className="button-next mt-3"
                variant="primary"
                disabled={isLoading}
                onClick={(e) => {
                  e.preventDefault()
                  let valid = validateFields()
                  if (valid) {
                    setIsLoading(true)
                    
                    let formData = new FormData()
                    formData.append('company_id', currentCompany.id)
                    formData.append('provider_id', provider.id)
                    formData.append('form_type', 'cloud_telephony')
                    formData.append('form_data', JSON.stringify(data))

                    masterAgentService
                      .saveFormOpportunity(formData)
                      .then(() => {
                        Swal.fire({
                          title: 'Sucesso!',
                          text: 'Oportunidade enviada!',
                          icon: 'success',
                          timer: 3000,
                          showConfirmButton: false,
                          timerProgressBar: true,
                          allowOutsideClick: false,
                        }).then(result => {
                          if (result.isDismissed) history.goBack()
                        })
                      })
                      .catch(e => swal.error(e))
                      .finally(() => setIsLoading(false))
                  }
                }}
              >
                {isLoading ? (<>
                  Enviando <Spinner animation="border" size="sm" />
                </>) : "Enviar"}
              </Button>
            </Form>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </>)
}

export default CloudTelephonyForm